<div class="container-inco new-table-style">
  <div class="header-container">
    <div class="header-left">
      <h2>{{title}}</h2>
    </div>
  </div>
  <div>
    <app-masterdata-table></app-masterdata-table>
  </div>
</div>